<template>
  <div>
    <div class="nav" :class="isShow ? 'bg' : ''">
      <ul class="flex">
        <img
          v-if="!isShow"
          class="top_logo"
          :class="isMobile ? 'mLeft' : ''"
          src="../assets/top_logo.png"
        />
        <img
          v-if="isShow"
          class="top_logo"
          :class="isMobile ? 'mLeft' : ''"
          src="../assets/top_logo1.png"
        />
        <div v-if="!isMobile" class="flex">
          <template v-for="(item, idx) in items">
            <li :key="idx">
              <a
                @click="toPuth(item.url)"
                :class="cIdx == idx ? 'checkedStyle' : ''"
                >{{ item.txt }}</a
              >
              <SecNav v-if="item.children" :items="item.children"></SecNav>
            </li>
          </template>
          <img v-if="!isShow" class="phone_img" src="../assets/phone.png" />
          <img v-if="isShow" class="phone_img" src="../assets/phone1.png" />
          <div class="phone_tx">15801031606</div>
        </div>
        <div v-if="isMobile" class="flex" @click="menuBtn()">
          <img
            v-if="!isShow"
            class="right_menu"
            src="../assets/right_menu1.svg"
          />
          <img
            v-if="isShow"
            class="right_menu"
            src="../assets/right_menu2.svg"
          />
        </div>
      </ul>
    </div>
    <div v-if="isRightMenu" class="rightMenu">
      <div class="col" v-for="(item, idx) in items" :key="idx">
        <li>
          <a
            @click="toPuth(item.url)"
            :class="cIdx == idx ? 'checkedStyle' : ''"
            >{{ item.txt }}</a
          >
        </li>
      </div>
    </div>
    <div v-if="isRightMenu" class="mask" @click="mask"></div>
  </div>
</template>

<script>
import SecNav from "./SecNav.vue";

export default {
  name: "HeaderNavigation",
  components: { SecNav },
  props: {
    scrollTop: {
      type: Number,
      default: null,
    },
    cIdx: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      items: [
        { txt: "首页", url: "/" },
        { txt: "唯一性检测", url: "/equipment" },
        { txt: "行业设备", url: "/detection" },
        { txt: "智能柜控制系统", url: "/system" },
        { txt: "虹膜识别", url: "/iris" },
        { txt: "新闻中心", url: "/news" },
        { txt: "关于思源", url: "/about" },
        // {
        //   txt: "售前咨询",
        //   url: "/",
        //   children: [
        //     { txt: "旅行路线", url: "/" },
        //     { txt: "安全保障", url: "/" },
        //     { txt: "自助查询", url: "/" },
        //     { txt: "人工客服", url: "/" },
        //   ],
        // },
      ],
      isShow: false,
      isRightMenu: null,
    };
  },
  watch: {
    scrollTop: {
      handler() {
        if (this.scrollTop > 400) {
          this.isShow = true;
        } else {
          this.isShow = false;
        }
      },
    },
    // isMobile: {
    //   handler(val) {
    //     console.log("----", val);
    //   },
    // },
  },
  computed: {
    isMobile() {
      // 布尔值，指示当前设备是否被认为是移动设备
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
        userAgent
      );
    },
  },
  methods: {
    toPuth(url) {
      this.$router.push({ path: url });
    },
    menuBtn() {
      this.isRightMenu = !this.isRightMenu;
    },
    mask() {
      this.isRightMenu = false;
    },
  },
};
</script>

<style lang="scss">
@media screen and (max-width: 768px) {
  .nav {
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 9999;
    padding: 10px;
    .top_logo {
      width: 528px;
      height: 160px;
      margin: auto 0;
      // margin: 20px 40px 20px 4%;
    }
  }
  /* 在此处添加适应移动设备屏幕的样式规则 */
  .rightMenu {
    position: fixed;
    top: 13.5rem;
    right: 0px;
    width: 32%;
    z-index: 9999;
    color: #333;
    background: #fff;
    padding: 20px;
    border-radius: 20px;
    li {
      flex-grow: 1;
      padding: 15px 2px;
      height: 220px;
      line-height: 220px;
      text-align: center;
      list-style: none;
      position: relative;
      border-bottom: 1px solid #f5f5f5;
      a {
        display: inline-block;
        text-decoration: none;
        line-height: 40px;
        font-weight: 500;
        font-family: PingFang SC;
        font-size: 52px;
      }
      a:hover {
        color: rgb(184, 231, 14);
        margin: auto 0;
        border-bottom: 2px solid rgb(184, 231, 14);
        border-radius: 8px;
      }
      .checkedStyle {
        color: rgb(184, 231, 14);
        margin: auto 0;
        border-bottom: 2px solid rgb(184, 231, 14);
        border-radius: 2px;
      }
    }
    li:hover {
      cursor: pointer;
    }
    li:hover .sec-nav {
      display: inline-block;
      z-index: 2;
    }
  }
}

@media screen and (min-width: 1200px) {
  /* PC版样式 */
  .nav {
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 9999;
    color: white;
    height: 80px;
    line-height: 80px;
    ul {
      display: flex;
      list-style: none;
      margin: 0;
      justify-content: space-around;
      li {
        flex-grow: 1;
        padding: 15px 2px;
        line-height: 50px;
        height: 50px;
        text-align: center;
        position: relative;
        a {
          display: inline-block;
          text-decoration: none;
          line-height: 40px;
          font-family: PingFang SC;
          font-size: 18px;
        }
        a:hover {
          color: rgb(184, 231, 14);
          margin: auto 0;
          border-bottom: 2px solid rgb(184, 231, 14);
          border-radius: 8px;
        }
        .checkedStyle {
          margin: auto 0;
          border-bottom: 2px solid rgb(184, 231, 14);
          border-radius: 2px;
        }
      }
      li:hover {
        cursor: pointer;
      }
      li:hover .sec-nav {
        display: inline-block;
        z-index: 2;
      }
    }
    .top_logo {
      width: 132px;
      height: 40px;
      margin: auto 0 auto 2%;
      // margin: 20px 40px 20px 4%;
    }
    .phone_img {
      width: 26px;
      height: 26px;
      margin: 27px 10px 0 6%;
    }
    .phone_tx {
      font-family: PingFang SC;
      font-size: 24px;
      font-weight: 500;
      line-height: 80px;
      text-align: center;
      margin-right: 6%;
    }
  }
}

.bg {
  background: #f5f5f5;
  color: #333 !important;
}
.right_menu {
  margin: auto 4% auto auto;
}
.mLeft {
  margin-left: -7% !important;
}
.mask {
  position: fixed;
  inset: 0px 0px 0px;
  z-index: 999;
  background-color: rgb(0, 0, 0);
  opacity: 0.5;
  display: block;
}
</style>
